export { default } from './ArtistIdentityProfile';
